var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"none","padding":"0","width":"100%","height":"100%"},attrs:{"src":("http://docs.google.com/viewer?url=" + _vm.url + "&embedded=true")}})}
var staticRenderFns = []

export { render, staticRenderFns }